import { View } from 'foundations-components/components/View';
import { AbstractPageTemplate } from 'foundations-components/transitional/components/AbstractPageTemplate';
import { useTheme } from 'foundations-theming/utils';
import styled from 'foundations-theming/utils';
import { Hero } from '../hero/components/Hero';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDashboardPageWrapper = styled.div.withConfig({
  displayName: "DashboardPageWithHero__StyledDashboardPageWrapper",
  componentId: "sc-1yavjcm-0"
})(["overflow-x:hidden;"]);
const FullWidthLineContainer = styled.div.withConfig({
  displayName: "DashboardPageWithHero__FullWidthLineContainer",
  componentId: "sc-1yavjcm-1"
})(["width:100vw;position:relative;left:50%;transform:translateX(-50%);border-top:1px solid ", ";"], ({
  theme
}) => theme.color['border-core-subtle']);
export function DashboardPageWithHero({
  children,
  headerComponent
}) {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(StyledDashboardPageWrapper, {
    children: /*#__PURE__*/_jsx(AbstractPageTemplate, {
      headerComponent: /*#__PURE__*/_jsxs(View, {
        children: [headerComponent, /*#__PURE__*/_jsx(FullWidthLineContainer, {}), /*#__PURE__*/_jsx(Hero, {})]
      }),
      horizontalDivider: false,
      mainSectionBackgroundColor: theme.color['fill-surface-recessed'],
      children: children
    })
  });
}